import axios from 'axios';
export const getRelatedProducts = (endpoint) => axios.get(endpoint).then((data) => data?.data);
